export const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'] as const

const QUARTER_DATES = {
    Q1: { start: '-01-01', end: '-03-31' },
    Q2: { start: '-04-01', end: '-06-30' },
    Q3: { start: '-07-01', end: '-09-30' },
    Q4: { start: '-10-01', end: '-12-31' },
}

export interface SurveyFilters {
    employee_ids: number[]
    customer_sale_followers: number[]
    customer_cs_followers: number[]
    execution_time_range: string[]
}

export const SURVEY_FILTER_DEFAULTS: SurveyFilters = {
    employee_ids: [],
    customer_sale_followers: [],
    customer_cs_followers: [],
    execution_time_range: [],
}

export const normalizeSurveyFilters = (
    filters: Partial<SurveyFilters>
): SurveyFilters => {
    const ids = (value: unknown) =>
        Array.isArray(value)
            ? [
                  ...new Set(
                      value
                          .map(Number)
                          .filter((id) => Number.isSafeInteger(id) && id > 0)
                  ),
              ]
            : []
    return {
        employee_ids: ids(filters.employee_ids),
        customer_sale_followers: ids(filters.customer_sale_followers),
        customer_cs_followers: ids(filters.customer_cs_followers),
        execution_time_range: [],
    }
}

export const getQuarterPeriod = (
    params: URLSearchParams,
    currentYear = new Date().getFullYear()
) => {
    const rawYear = params.get('rpt_year') || ''
    const year =
        /^\d{4}$/.test(rawYear) &&
        Number(rawYear) >= 1900 &&
        Number(rawYear) <= 9998
            ? rawYear
            : String(currentYear)
    const quarter = (
        value: string | null,
        fallback: (typeof QUARTERS)[number]
    ) => QUARTERS.find((q) => q === value) || fallback
    const from = quarter(params.get('rpt_from'), 'Q1')
    const requestedTo = quarter(params.get('rpt_to'), 'Q4')
    const to = requestedTo < from ? from : requestedTo
    return {
        year,
        from,
        to,
        from_date: `${year}${QUARTER_DATES[from].start}`,
        // Quarterly API takes the first day of the final quarter, inclusively.
        to_date: `${year}${QUARTER_DATES[to].start}`,
        execution_time_range: [
            `${year}${QUARTER_DATES[from].start}T00:00:00Z`,
            `${year}${QUARTER_DATES[to].end}T23:59:59Z`,
        ],
        periodRange:
            from === to ? `${year} (${from})` : `${year} (${from}–${to})`,
    }
}
